import React from 'react';
import sheet_of_documents from '../../../src/Assets/images/sheets of documents.png';
import { useNavigate } from 'react-router-dom';
const PricingNotice = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-orange-100 p-6 rounded-lg shadow-md max-w-3xl mx-auto text-xs">
      <div className="flex flex-col md:flex-row items-center gap-10">
        <img src={sheet_of_documents} alt="" className="w-auto h-24 " />
        <div>
          <h2 className="md:text-xl text-lg font-bold text-center mb-4 text-gray-800">
            Notice of Tender Publish Request
          </h2>
          <ul className="list-disc pl-6 text-gray-700">
          <li className="mb-2">
            You can send a request to publish any tender on Tender Wise.  <button
                onClick={() => navigate('/tenderpublish')}
                className="text-orange-500 font-semibold hover:underline"
              >
                Publish Tender
              </button>
            </li>
            
            <li className="mb-2">
              We will verify your tender request to publish.
            </li>
            <li className="mb-2">
              Publish your tender with a very cost-effective way of 1000 taka
              only.
            </li>
            <li className="mb-2">
              The tender page needs to be an A4 sized PDF with the company
              authorized seal.
            </li>
            <li className="mb-2">
              Upload your tender with seal and signature.{' '}
              <button
                onClick={() => navigate('/tenderpublishDetails')}
                className="text-orange-500 font-semibold hover:underline"
              >
                {/* Read more */}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PricingNotice;
